import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import style from './Images.module.scss'
import images from 'assets/images/images-bg.jpg'
import { ReactComponent as IconImg } from 'assets/images/icon-img.svg'
import { useState } from 'react';
import { useImages } from "./useImages";

const getIsMobile = () => window.innerWidth <= 768;

export const Images =()=> {
    const [isMob] = useState(getIsMobile())
    const { t } = useTranslation()
    const { data } = useImages()
    const hasImages = !!data?.length

    return (
        <div className={style.block} id="photo">
            <div className="container">
                <div className={style.wrap}>
                    <div className={style.content}>
                        <h2>{t('images.title')}</h2>
                        {(!isMob && hasImages) && <Link to="/image-gallery" className={['btn']}><IconImg/> {t('images.btn')}</Link>}
                    </div>
                    <div className={style.img}>
                        <picture>
                            <img src={images} alt="" width={980} height={480} />
                        </picture>
                    </div>
                    {(isMob && hasImages) &&
                        <div className={style.content}>
                            <Link to="/image-gallery" className={['btn']}><IconImg/> {t('images.btn')}</Link>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}